import React from 'react';

const LitigationIcon = () => {
  return (
    <>
      <svg
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34 26.4407V26.9167C34 28.6365 32.4672 29.9993 30.6921 29.7117C29.2981 29.4851 28.3333 28.1775 28.3333 26.7665V26.4407L29.5432 23.0123L26.9167 22.5193V31.1681H29.75C30.532 31.1681 31.1667 31.8013 31.1667 32.5847C31.1667 33.3682 30.532 34.0014 29.75 34.0014H21.25C20.468 34.0014 19.8333 33.3682 19.8333 32.5847C19.8333 31.8013 20.468 31.1681 21.25 31.1681H24.0833V21.9881L21.6013 21.5234L22.8211 24.9319V25.7465H22.8027C22.6199 27.3927 21.0658 28.6252 19.3092 28.2724C17.935 27.9976 17 26.6971 17 25.296V24.9503L18.5017 20.1634C18.8573 19.0287 20.0048 18.3387 21.1735 18.5555L24.0833 19.0952V18.4152C24.0833 17.6318 24.718 16.9986 25.5 16.9986C26.282 16.9986 26.9167 17.6318 26.9167 18.4152V19.6208L30.3308 20.2541C31.2871 20.4312 32.0776 21.1027 32.4063 22.0178L33.9986 26.4392L34 26.4407ZM12.75 17C17.4378 17 21.25 13.1877 21.25 8.5C21.25 3.81225 17.4378 0 12.75 0C8.06225 0 4.25 3.81225 4.25 8.5C4.25 13.1877 8.06225 17 12.75 17ZM14.1667 25.2946V24.5154L15.5323 20.162C14.6342 19.9594 13.7077 19.8333 12.75 19.8333C5.72759 19.8333 0.0127524 25.5397 2.38831e-06 32.5592C-0.00141428 33.3483 0.627586 34 1.41667 34H17.2607C17.102 33.5552 17 33.082 17 32.5833C17 31.8707 17.1927 31.2092 17.5043 30.6184C15.5182 29.6863 14.1667 27.6321 14.1667 25.2946Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default LitigationIcon;
